/**
 * Service Pos-venda / Assistencia ao Cliente (Fase 12 — ADR-0027).
 */

const PREFIXO = "/api/assistencias";

// ============================================================
// CRUD + actions
// ============================================================

export function listarAssistencias(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.situacao) usp.set("situacao", params.situacao);
  if (params.tipo) usp.set("tipo", params.tipo);
  if (params.prioridade) usp.set("prioridade", params.prioridade);
  if (params.pedido) usp.set("pedido", params.pedido);
  if (params.responsavel) usp.set("responsavel", params.responsavel);
  if (params.ativas) usp.set("ativas", "true");
  if (params.atrasadas) usp.set("atrasadas", "true");
  // O widget da Visão Geral só precisa da contagem: com paginação o backend
  // devolve `count` sem mandar a lista inteira.
  if (params.pageSize) usp.set("page_size", String(params.pageSize));
  const qs = usp.toString();
  return request(`${PREFIXO}${qs ? `?${qs}` : ""}`);
}

export function obterAssistencia(request, id) {
  return request(`${PREFIXO}/${id}`);
}

export function criarAssistencia(request, dados) {
  return request(PREFIXO, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

export function iniciarAnalise(request, id) {
  return request(`${PREFIXO}/${id}/iniciar-analise`, { method: "POST" });
}

export function iniciarResolucao(request, id) {
  return request(`${PREFIXO}/${id}/iniciar-resolucao`, { method: "POST" });
}

export function resolverAssistencia(request, id, { resolucao }) {
  return request(`${PREFIXO}/${id}/resolver`, {
    method: "POST",
    body: JSON.stringify({ resolucao }),
  });
}

export function cancelarAssistencia(request, id, { motivo }) {
  return request(`${PREFIXO}/${id}/cancelar`, {
    method: "POST",
    body: JSON.stringify({ motivo }),
  });
}

export function reabrirAssistencia(request, id, { motivo }) {
  return request(`${PREFIXO}/${id}/reabrir`, {
    method: "POST",
    body: JSON.stringify({ motivo }),
  });
}

export function escalonarAssistencia(request, id, { novo_responsavel_id, motivo }) {
  return request(`${PREFIXO}/${id}/escalonar`, {
    method: "POST",
    body: JSON.stringify({ novo_responsavel_id, motivo }),
  });
}

export function comentarAssistencia(request, id, { texto }) {
  return request(`${PREFIXO}/${id}/comentar`, {
    method: "POST",
    body: JSON.stringify({ texto }),
  });
}

// ============================================================
// Labels e tones (UI)
// ============================================================

export const TIPOS_ASSISTENCIA = [
  { value: "GARANTIA", label: "Garantia" },
  { value: "DEFEITO_FABRICACAO", label: "Defeito de fabricação" },
  { value: "DEFEITO_INSTALACAO", label: "Defeito de instalação" },
  { value: "ERRO_PEDIDO", label: "Erro de pedido" },
  { value: "RECLAMACAO", label: "Reclamação" },
  { value: "DUVIDA", label: "Dúvida" },
  { value: "OUTROS", label: "Outros" },
];

export const TIPO_LABELS = Object.fromEntries(
  TIPOS_ASSISTENCIA.map((t) => [t.value, t.label]),
);

export const PRIORIDADES = [
  { value: "BAIXA", label: "Baixa", tone: "neutral" },
  { value: "MEDIA", label: "Média", tone: "info" },
  { value: "ALTA", label: "Alta", tone: "warning" },
  { value: "CRITICA", label: "Crítica", tone: "danger" },
];

export const PRIORIDADE_LABELS = Object.fromEntries(
  PRIORIDADES.map((p) => [p.value, p.label]),
);

export const PRIORIDADE_TONES = Object.fromEntries(
  PRIORIDADES.map((p) => [p.value, p.tone]),
);

export const SITUACAO_LABELS = {
  ABERTA: "Aberta",
  EM_ANALISE: "Em análise",
  EM_RESOLUCAO: "Em resolucao",
  RESOLVIDA: "Resolvida",
  CANCELADA: "Cancelada",
};

export const SITUACAO_TONES = {
  ABERTA: "warning",
  EM_ANALISE: "info",
  EM_RESOLUCAO: "info",
  RESOLVIDA: "success",
  CANCELADA: "neutral",
};

// Ordem das colunas no Kanban
export const SITUACOES_KANBAN = ["ABERTA", "EM_ANALISE", "EM_RESOLUCAO", "RESOLVIDA", "CANCELADA"];

export function formatarHorasRestantes(horas) {
  if (typeof horas !== "number" || Number.isNaN(horas)) return "—";
  if (horas < 0) return `Atrasada ${Math.abs(Math.round(horas))}h`;
  if (horas < 1) return `${Math.round(horas * 60)}min restantes`;
  if (horas < 24) return `${Math.round(horas)}h restantes`;
  return `${Math.round(horas / 24)}d restantes`;
}
